import React, {useState} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {toggleShowAssignQuotePopup} from "../../../actions/assignPopupFunctions";
import WithOverlay from "../withOverlayHoc";
import AssignQuotePopupContent from "./assignQuotePopupContent";
import AssignQuotePopupNewCustomer from "./assignQuotePopupNewCustomer";
import AssignQuotePopupSaveButtons from "./assignQuotePopupSaveButtons";
import {CONTENT_TYPES} from "./assignQuoteConstants";
import AssignPopupContext, {initialContext} from './assignPopupContext';
import Config from "../../../config";
import AgreeEmailCheckbox from "../../common/agreeEmailCheckbox";

const AssignQuotePopup = (props) => {

  const {toggleShowAssignQuotePopup, showAssignQuotePopup} = props;
  const [contentType, setContentType] = useState(CONTENT_TYPES.searchCustomer);
  const [context, setContext] = useState(initialContext);

  if (!showAssignQuotePopup) {
    return null
  }

  const closePopup = () => {
    toggleShowAssignQuotePopup(false);
    setContentType(CONTENT_TYPES.searchCustomer);
  };

  const changeContent = () => {
    setContentType(contentType === CONTENT_TYPES.newCustomer
      ? CONTENT_TYPES.searchCustomer
      : CONTENT_TYPES.newCustomer
    );
    setContext({...context, customerError: ""});
  };

  const updateInputValidations = () => {
    setContext({...context, inputsValidated: false});
    return new Promise((resolve) => {
      setTimeout(() => {
        setContext({...context, inputsValidated: false});
        resolve()
      }, 300); // wait until redux store is updated with input Errors
    });
  };

  const changeContext = (newContextValues) => {
    setContext({...context, ...newContextValues});
  };

  const agreeEmailCheckboxVisible = Config.isDevMode() || document.kvConfig.isBackend;

  return (
    <WithOverlay closePopup={closePopup}>
      {(hideOverlay) => (
        <AssignPopupContext.Provider value={context} setContext={setContext}>
          <div className="ui-popup ass-popup">
            <div className="ui-popup__header">
            <span className="ui-popup__header-title">
              <FormattedMessage id={
                contentType === CONTENT_TYPES.searchCustomer ? "assignPopup.title" : "assignPopup.newCustomer.title"
              }/>
            </span>
              {contentType === CONTENT_TYPES.searchCustomer ? (
                <button className="ui-button2 ui-button2--green ui-button2--green-plus ass-content-button" onClick={changeContent}>
                  <FormattedMessage id="assignPopup.addCustomerButton"/>
                </button>
              ) : null}
            </div>
            <div className="ui-popup__body">
              <AssignQuotePopupContent isActive={contentType === CONTENT_TYPES.searchCustomer} changeContext={changeContext}/>
              <AssignQuotePopupNewCustomer isActive={contentType === CONTENT_TYPES.newCustomer}/>
            </div>
            <div className={"ui-popup__footer" + (agreeEmailCheckboxVisible ? " ui-popup__footer--with-sides" : "")}>
              {agreeEmailCheckboxVisible ? (
                <div className="ui-popup__footer-left">
                  <AgreeEmailCheckbox/>
                </div>
              ) : null}
              <div className="ui-popup__footer-right nowrap">
                <button className="selection-footer-buttons__button selection-footer-buttons__button--prev" onClick={() => {
                  contentType === CONTENT_TYPES.searchCustomer ? hideOverlay(closePopup) : changeContent()
                }}>
                  <FormattedMessage id="assignPopup.backButton"/>
                </button>
                <AssignQuotePopupSaveButtons closePopup={hideOverlay.bind(this, closePopup)}
                                             updateInputValidations={updateInputValidations}
                                             changeContext={changeContext}
                                             contentType={contentType}/>
              </div>
            </div>
          </div>
        </AssignPopupContext.Provider>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  return {
    showAssignQuotePopup: store.assignQuoteState.showAssignQuotePopup,
  };
};

const mapDispatchToProps = {
  toggleShowAssignQuotePopup
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopup)
)
